<template>
    <section v-if="quote" class="section">
        <div class="columns is-desktop mtb-80">

            <div class="column mb-40">
                <span class="title-icon fa fa-warning fa-2x center has-text-danger"></span>
                <h3 class="dotted-line is-size-5 has-text-weight-bold">Pomembno</h3>
                <p class="has-text-centered">POZOR - ko odhajate v naravo: skrbno pazite na vaše ljubljenčke in imejte telefonsko številko veterinarja vedno pri sebi.</p>
            </div>
            <div class="column max-width" id="weather">
                <app-weather language="sl-si" title="današnje vreme"></app-weather>
            </div>
            <div class="special-blockquote complex-line column" :class="classObj">
                <span class="related weather"></span>

                <blockquote class="item">
                    <span>{{ quote.quote }}</span>
                    <cite>{{ quote.author }}</cite>
                </blockquote>
            </div>

        </div>
    </section>
</template>

<script>
import Weather from '../elements/weather/Weather';
export default {
    name: 'app-action-call-general',
    props: ['quote', 'zeroPadding'],
    components: {
        'app-weather': Weather
    },
    computed: {
        classObj() {
            if (this.zeroPadding !== undefined) {
                return ' padding0';
            } else {
                return ' padding30';
            }
        },
    },
    data() {
        return {
            //
        };
    },

}
</script>

<style lang="scss" scoped>

.title-icon {
    float: left;
    margin-right: 20px;
}
.flex-blockquote {
    display:flex !important;
    justify-content: space-between;
    align-content: center;
    flex-flow: row wrap;
    .item {
        max-width: 400px;
        align-self: center;
    }
    /* blockquote::before {
        top: -20px;
        left: -15px;
    }
    blockquote::after {
        content: "\F10D";
        font-family: "FontAwesome";
        background: transparent;
        color: #b5b5b5;
    } */

}
</style>


// WEBPACK FOOTER //
// src/components/complex/CaGeneral.vue